import { PageType } from '@core/enums';
import { ThemeOption } from '@helpers/brand';
import { Device, until } from '@helpers/media';
import { withMotionMax } from '@hoc/withMotionMax';
import ArticleCard from '@stories/Components/Cards/ArticleCard/ArticleCard';
import CtaCard from '@stories/Components/Cards/CtaCard/CtaCard';
import EventCard from '@stories/Components/Cards/EventCard/EventCard';
import ResourceCard from '@stories/Components/Cards/ResourceCard/ResourceCard';
import CarouselProvider from '@stories/Components/Carousels/Carousel/CarouselProvider/CarouselProvider';
import Connected from '@stories/Components/Carousels/Carousel/Connected/Connected';
import DotPagination from '@stories/Components/Global/DotPagination/DotPagination';
import { MotionConfig } from 'framer-motion';
import React from 'react';
import { useMedia } from 'react-use';
import { RelatedCardsStyles as S } from './RelatedCards.styles';
const RelatedCards = ({ content, id, items, pageType, paginationAriaLabel, theme = ThemeOption.Orange, }) => {
    // Only want carousel behavior on mobile layout.
    const enableCarousel = useMedia(until(Device.TabletSmall), false);
    const wrapper = React.useRef(null);
    if (!items.length) {
        return null;
    }
    return (React.createElement(MotionConfig, { transition: { duration: 0.45, ease: 'easeOut' } },
        React.createElement(CarouselProvider, { count: items.length },
            React.createElement(S.ContentContainer, { id: id, innerWidth: "narrow", flush: "top" },
                React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } })),
            items && (React.createElement(S.CardsContainer, { ref: wrapper, innerWidth: "reduced", "data-page-type": pageType },
                React.createElement(S.Track, { trackMutations: true, enableCarousel: enableCarousel, mobileOnly: true }, items.map((item, i) => (React.createElement(S.Item, { key: `card-${i}` }, renderCardType(item, i))))),
                React.createElement(Connected, null, (carousel) => (React.createElement(S.PaginationWrapper, null,
                    React.createElement(S.Pagination, null,
                        React.createElement(DotPagination, { ariaLabel: paginationAriaLabel, count: carousel.maxIndex + 1, value: carousel.activeIndex, onChange: (index) => carousel.goToIndex(index) }))))))))));
    function renderCardType(item, index) {
        switch (pageType) {
            case PageType.News:
                return React.createElement(ArticleCard, { key: `item-${index}`, ...item, theme: theme });
            case PageType.Content:
                return React.createElement(CtaCard, { key: `item-${index}`, ...item, theme: theme });
            case PageType.Events:
                return React.createElement(EventCard, { key: `item-${index}`, ...item, theme: theme });
            case PageType.Resources:
            case PageType.CGeogMembers:
                return (React.createElement(ResourceCard, { key: `item-${index}`, ...item, theme: theme }));
        }
    }
};
export default withMotionMax(RelatedCards);
